import React from 'react'

import { HeadingMedium, FadeIn, Spinner, Panel, Label } from '@pb/components'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import SecondaryAction from 'ui/buttons/SecondaryAction'

import { operationFetchMonthlyInvoices } from '../../duck/operations'
import selectors from '../../duck/selectors'
import MonthlyInvoice from '../MonthlyInvoice'
import styles from './MonthlyInvoiceList.scss'

const MonthlyInvoiceList: React.FC<any> = ({
  invoiceIds = [],
  title,
  shouldShowLoadMoreButton,
  loadMoreInvoices,
  isLoadingMore,
  className,
  filterName,
}) => (
  <Panel className={cn(className)} padding="none none l none">
    {invoiceIds.length > 0 && (
      <Panel padding="xs m">
        <HeadingMedium>
          {title ? (
            <Label copyKey={title} />
          ) : (
            <Label copyKey="omni.hmxklarna.allinvoices.tab.monthly.invoices.heading" />
          )}
        </HeadingMedium>
      </Panel>
    )}
    <ul>
      {invoiceIds.map((invoiceId) => (
        <MonthlyInvoice
          key={filterName + invoiceId}
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ key: any; invoiceId: any; filterName: any;... Remove this comment to see the full error message
          invoiceId={invoiceId}
          filterName={filterName}
        />
      ))}
    </ul>
    {shouldShowLoadMoreButton && (
      <FadeIn delay={75 * invoiceIds.length}>
        <Panel padding="m m none m">
          <SecondaryAction
            size="large"
            onClick={loadMoreInvoices}
            className={styles.loadMoreButton}
            disabled={isLoadingMore}
          >
            <Spinner isRendered={isLoadingMore} containerClassName={styles.spinner} />
            <Label copyKey="omni.hmxklarna.allinvoices.tab.monthly.invoices.load.button" />
          </SecondaryAction>
        </Panel>
      </FadeIn>
    )}
  </Panel>
)

MonthlyInvoiceList.propTypes = {
  invoiceIds: PropTypes.array,
  title: PropTypes.string,
  shouldShowLoadMoreButton: PropTypes.bool.isRequired,
  loadMoreInvoices: PropTypes.func.isRequired,
  isLoadingMore: PropTypes.bool,
  filterName: PropTypes.string.isRequired,
}

const mapStateToProps = (state): any => {
  const isLoadingMore = selectors.getMonthlyInvoicesIsLoading(state)

  return {
    isLoadingMore,
  }
}

const mapDispatchToProps = (dispatch): any => {
  const loadMoreInvoices = (): any => dispatch(operationFetchMonthlyInvoices())

  return {
    loadMoreInvoices,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyInvoiceList)
